import { SubscriptionDto, SubscriptionVersion } from '@/api/contracts/models'
import { useSubscriptionQueryPrefetch } from '@/composables/queries/useSubscriptionQuery'
import QueryKeys from '@/vue-query/QueryKeys'
import { QueryClient } from 'vue-query'
import { NavigationGuardWithThis } from 'vue-router'
const myClient = new QueryClient()

const v1SubscriptionGuard: NavigationGuardWithThis<undefined> = async (
  _to,
  _from,
  next,
) => {
  const queryClient = myClient
  let data = queryClient.getQueriesData<SubscriptionDto>({
    queryKey: [QueryKeys.Subscription],
  })

  if (data.length === 0) {
    await useSubscriptionQueryPrefetch(queryClient)
    data = queryClient.getQueriesData<SubscriptionDto>({
      queryKey: [QueryKeys.Subscription],
    })
  }

  if (data[0][1]?.version === SubscriptionVersion.V1) {
    next()
  } else {
    next({ name: 'app' })
  }
}

export default v1SubscriptionGuard
